export const device = {
  tabLand: `(max-width: 75em)`, // < 1200
  tabPort: `(max-width: 56.25em)`, // < 900
  phone: `(max-width: 37.5em)`, // < 600
};
